var moduleMap = {
	"./init": function() {
		return Promise.all([__webpack_require__.e(109), __webpack_require__.e(714), __webpack_require__.e(131), __webpack_require__.e(83)]).then(function() { return function() { return (__webpack_require__(18083)); }; });
	},
	"./routes": function() {
		return Promise.all([__webpack_require__.e(547), __webpack_require__.e(109), __webpack_require__.e(508), __webpack_require__.e(694), __webpack_require__.e(78), __webpack_require__.e(714), __webpack_require__.e(131), __webpack_require__.e(713), __webpack_require__.e(377)]).then(function() { return function() { return (__webpack_require__(91070)); }; });
	},
	"./Navigation": function() {
		return Promise.all([__webpack_require__.e(109), __webpack_require__.e(78), __webpack_require__.e(131), __webpack_require__.e(383)]).then(function() { return function() { return (__webpack_require__(65383)); }; });
	},
	"./calendar/ClientContentCalendarCard": function() {
		return Promise.all([__webpack_require__.e(385), __webpack_require__.e(547), __webpack_require__.e(109), __webpack_require__.e(508), __webpack_require__.e(564), __webpack_require__.e(78), __webpack_require__.e(179), __webpack_require__.e(714), __webpack_require__.e(850), __webpack_require__.e(131), __webpack_require__.e(713), __webpack_require__.e(681)]).then(function() { return function() { return (__webpack_require__(27104)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});